// extracted by mini-css-extract-plugin
export var arrowContainer = "postNavigation-module--arrowContainer--b709b";
export var arrowLink = "postNavigation-module--arrowLink--b2e9f";
export var arrowLinkContainer = "postNavigation-module--arrowLinkContainer--01f33";
export var categoriesLink = "postNavigation-module--categoriesLink--778ad";
export var imgContainer = "postNavigation-module--imgContainer--b1397";
export var linkMainContainer = "postNavigation-module--linkMainContainer--90fbf";
export var linkTitleContainer = "postNavigation-module--linkTitleContainer--6b5d9";
export var navImg = "postNavigation-module--navImg--7ad5f";
export var navigationContainer = "postNavigation-module--navigationContainer--4cca1";
export var nextArrow = "postNavigation-module--nextArrow--99f3b";
export var prvArrow = "postNavigation-module--prvArrow--d0802";